import React from "react";
import styles from "./TechFlipCard.module.css";

interface TechFlipCardProps {
  front: string;
  back: string;
  isFlipped: boolean;
}

const TechFlipCard: React.FC<TechFlipCardProps> = ({ front, back, isFlipped }) => {
  return (
    <div className={`${styles.flipCard} ${isFlipped ? styles.flip : ""}`}>
      <div className={styles.flipInner}>
        <div className={styles.flipFront}>
          <img src={front} alt="front" />
        </div>
        <div className={styles.flipBack}>
          <img src={back} alt="back" />
        </div>
      </div>
    </div>
  );
};

export { TechFlipCard };
export default React.memo(TechFlipCard);
